export default __webpack_public_path__ + "static/media/ict-award-logo.7def6e43.jpg";